import CustomField from 'elements/field/CustomField'
import { styled } from 'opensolar-ui'

export const TooltipContent = styled('div')({
  fontSize: 13,
  lineHeight: '1.6',
  maxWidth: 400,
  padding: '4px 0',
})

export const TooltipContentWide = styled('div')({
  fontSize: 13,
  lineHeight: '1.6',
  maxWidth: 900,
  minWidth: 700,
  padding: '4px 0',
})

export const TooltipTableRow = styled('div')({
  display: 'flex',
  transition: 'background-color 0.2s ease',
  '&:not(:last-child)': {
    borderBottom: '1px solid rgba(255, 255, 255, 0.08)',
  },
  '&:hover': {
    backgroundColor: 'rgba(255, 255, 255, 0.08)',
  },
  '&:first-child': {
    '& > div:first-child': {
      paddingTop: 12,
    },
    '& > div:last-child': {
      paddingTop: 12,
    },
  },
  '&:last-child': {
    '& > div:first-child': {
      paddingBottom: 12,
    },
    '& > div:last-child': {
      paddingBottom: 12,
    },
  },
})

export const TooltipTableCell = styled('div')({
  padding: '10px 16px',
  fontSize: 13,
  lineHeight: '1.5',
  '&:first-child': {
    fontWeight: 600,
    color: 'rgba(255, 255, 255, 0.95)',
    width: '32%',
    paddingRight: 20,
    letterSpacing: '0.01em',
    flexShrink: 0,
  },
  '&:last-child': {
    width: '68%',
    color: 'rgba(255, 255, 255, 0.85)',
    flex: 1,
  },
})

export const TooltipContentNarrow = styled('div')({
  fontSize: 13,
  lineHeight: '1.6',
  maxWidth: 350,
  padding: '4px 0',
})

export const TooltipSectionHeader = styled('div')({
  fontWeight: 600,
  marginBottom: 12,
  fontSize: 14,
})

export const TooltipSection = styled('div')({
  marginBottom: 12,
})

export const TooltipItem = styled('div')({
  marginBottom: 8,
  '&:last-child': {
    marginBottom: 0,
  },
})

export const TooltipDivider = styled('div')({
  fontWeight: 600,
  marginTop: 12,
  marginBottom: 8,
  fontSize: 14,
  borderTop: '1px solid rgba(255,255,255,0.2)',
  paddingTop: 12,
})

export const TooltipItemSpaced = styled('div')({
  marginBottom: 12,
})

export const TooltipDescription = styled('div')({
  marginBottom: 12,
})

export const TooltipBulletItem = styled('div')({
  marginBottom: 8,
  '&:last-child': {
    marginBottom: 0,
  },
})

export const SubsectionHeader = styled('h3')({
  fontSize: 14,
  marginTop: 20,
  marginBottom: 10,
})

export const FieldWithTooltipContainer = styled('div')({
  display: 'flex',
  alignItems: 'flex-start',
  gap: 8,
  marginBottom: 8,
})

export const FieldWrapper = styled('div')({
  width: 200, // matches styles.detailStyle.width
})

export const TooltipIconWrapper = styled('div')({
  marginTop: 4,
  display: 'flex',
  alignItems: 'center',
})

export const DependentFieldContainer = styled('div')({
  display: 'flex',
  alignItems: 'flex-start',
  gap: 8,
})

export const StyledAutoSetYearsToSimulate = styled('div')({
  height: 70,
  justifyContent: 'flex-end',
})

export const StyledAutoSetYearsToSimulateToggle = styled(CustomField)({
  marginTop: 8,
})

// Responsive tooltip styled components
export const TooltipContainer = styled('div')({
  width: '100%',
  maxWidth: '100%',
  fontSize: 13,
  lineHeight: 1.6,
  color: 'inherit',
})

export const TooltipHeader = styled('div')({
  fontWeight: 600,
  marginBottom: 12,
  fontSize: 14,
  color: 'inherit',
})

export const TooltipTable = styled('div')({
  borderRadius: 6,
  overflow: 'hidden',
  backgroundColor: 'rgba(0, 0, 0, 0.04)',
  border: '1px solid rgba(0, 0, 0, 0.12)',
  marginBottom: 12,
})

export const TooltipRow = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  borderBottom: '1px solid rgba(0, 0, 0, 0.08)',
  padding: '12px 16px',
  '&:last-child': {
    borderBottom: 'none',
  },
  [theme.breakpoints.up('sm')]: {
    flexDirection: 'row',
  },
}))

export const TooltipLabel = styled('div')(({ theme }) => ({
  fontWeight: 600,
  width: '100%',
  marginBottom: 8,
  flexShrink: 0,
  color: 'inherit',
  [theme.breakpoints.up('sm')]: {
    width: '28%',
    marginBottom: 0,
    paddingRight: 12,
    borderRight: '1px solid rgba(0, 0, 0, 0.08)',
  },
}))

export const TooltipDescriptionCell = styled('div')(({ theme }) => ({
  width: '100%',
  flex: 1,
  color: 'inherit',
  opacity: 0.9,
  [theme.breakpoints.up('sm')]: {
    width: '72%',
    paddingLeft: 16,
  },
}))

export const TooltipFooter = styled('div')({
  fontSize: 13,
  lineHeight: 1.6,
  color: 'inherit',
  opacity: 0.85,
})
